import React from "react"
import { FontIcon } from "material-ui"
import strings from "../../../localization/strings"
import { grey500 } from "material-ui/styles/colors"
interface IProps {
  url: string
  fontSize?: string
  iconColor?: string
  className?: string
}

const ExternalLink: React.SFC<IProps> = (props: IProps) => {
  return (
    <a
      title={strings.Oepn_Detail_In_New_Tab}
      href={props.url}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none" }}
    >
      <FontIcon style={{ fontSize: props.fontSize ? props.fontSize : 22 }} className={props.className ? props.className : "fa fa-external-link"} color={props.iconColor ? props.iconColor : grey500} />
    </a>
  )
}

export default ExternalLink